import translations from './gallium.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/gallium'

export const gallium: Metal = {
  id: 25,
  slug: 'gallium',
  name: t.name,
  symbol: 'Ga',
  // The sheet's pins are processing facilities, not mines: gallium has no mines of its
  // own, it is recovered where bauxite and zinc are refined. Markers still render as
  // "{metal} mine" (BGMap.translations) — see the note on the map-label wording.
  mines: [
    {
      name: 'Xiaoyi (China, gallium processing)',
      region: 'Xiaoyi',
      coordinates: [111.78, 37.15],
    },
    {
      name: 'Baotou (China, gallium processing)',
      region: 'Baotou',
      coordinates: [109.84, 40.66],
    },
    {
      name: 'Kunming (China, gallium processing)',
      region: 'Kunming',
      coordinates: [102.72, 25.04],
    },
    {
      name: 'Freiberg (Germany, gallium processing)',
      region: 'Freiberg',
      coordinates: [13.34, 50.92],
    },
    {
      name: 'Krasnoyarsk (Russia, gallium processing)',
      region: 'Krasnoyarsk',
      coordinates: [92.89, 56.02],
    },
  ],
  countries: [
    { name: 'China', percent: 98.7 },
    { name: 'Russia', percent: 0.8 },
    { name: 'Japan', percent: 0.4 },
    { name: 'South Korea', percent: 0.4 },
  ],
  important: true,
  // Recovered from the bauxite that aluminium is made from — the sheet's one related
  // metal, and a genuine co-product relationship rather than a thematic pairing.
  related: ['aluminium'],
  video: {
    name: 'gallium',
    poster: '/mine-my-phone/images/posters/gallium.jpg',
  },
  // Scores and imagery are authored here; every word comes from the translations file.
  content: {
    smartphone: {
      quantityScore: 1,
      quantityLabel: t.smartphone.label,
      parts: ['screen', 'camera', 'electronics'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 2, ...t.impacts.environmental },
      human: { severity: 2, ...t.impacts.human },
      geopolitical: { severity: 3, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 4, ...t.supplyRisk },
    recycling: { score: 1, ...t.recycling },
    footnotes: t.footnotes,
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
        credit: 'Bloomberg / Getty',
      },
      firstBento: [
        {
          src: `${dir}/02.jpg`,
          orientation: 'vertical',
          credit: "Quinn Glabicki / Pittsburgh's Public Source",
        },
        {
          src: `${dir}/03.jpg`,
          orientation: 'vertical',
        },
      ],
    },
  },
}
